import { IconButton } from '@xemplo/icon-button';
import { DawnPencilEdit } from '@xemplo/icons';

interface EditPayrunMilestonesButtonProps {
  onClick: () => void;
  renderButton?: (onClick: () => void) => React.ReactNode;
}

export function EditPayrunMilestonesButton({
  onClick,
  renderButton,
}: Readonly<EditPayrunMilestonesButtonProps>) {
  if (renderButton) return <>{renderButton(onClick)}</>;

  return (
    <IconButton
      ariaLabel="Edit payrun milestones button"
      id="edit-payrun-milestone-button"
      onClick={onClick}
    >
      <DawnPencilEdit fontSize={24} />
    </IconButton>
  );
}
